import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Point } from 'chart.js';
import Chart from 'chart.js/auto';
import annotationPlugin from 'chartjs-plugin-annotation';
Chart.register(annotationPlugin);

@Component({
    selector: 'app-combined-vertical-bar-chart',
    templateUrl: './combined-vertical-bar-chart.component.html',
    styleUrls: ['./combined-vertical-bar-chart.component.scss']
})
export class CombinedVerticalBarChartComponent implements OnInit, AfterViewInit {
    @ViewChild('chart')
    private chartRef: ElementRef;
    private chart: Chart;
    private data: Point[];

    @Input() datasets: any = null;
    @Input() labels: any = null;
    @Input() options: any = null;
    @Input() mean: any = null;

    constructor() {}

    ngOnInit(): void {
        if (this.mean) {
            this.options.plugins.annotation.annotations['mean'] = this.mean;
        }
    }

    ngAfterViewInit(): void {
        this.chart = new Chart(this.chartRef.nativeElement, {
            type: 'bar',
            data: { datasets: this.datasets, labels: this.labels },
            options: this.options
        });
    }
}
